import apiClient from '../api/client';

let _config = null;

export async function loadMetaAdsConfig() {
  if (_config) return _config;
  try {
    // apiClient supplies the real API base URL and the X-Tenant-ID header
    const res = await apiClient.get('/meta-ads/public-config');
    _config = res.data;
    return _config;
  } catch {
    return null;
  }
}

export async function initMetaAds() {
  const config = await loadMetaAdsConfig();
  if (!config?.enabled || !config?.pixelId) return;

  if (window.fbq) return;

  // Meta Pixel official snippet — minified IIFE form is intentional
  // eslint-disable-next-line no-unused-expressions
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  
  window.fbq('init', config.pixelId);
  window.fbq('track', 'PageView');
}

export async function fireMetaConversionEvent(eventName, data = {}, eventID = null) {
  const config = await loadMetaAdsConfig();
  if (!config?.enabled || !config?.pixelId) return;
  if (typeof window.fbq !== 'function') return;

  if (eventID) {
    window.fbq('track', eventName, data, { eventID });
  } else {
    window.fbq('track', eventName, data);
  }
}
